export default "__VITE_ASSET__72470ef1__"